import PortalIdParser from 'PortalIdParser';
import { CreditMemoOperation } from 'credit-memos-ui-lib/types/CreditMemoOperation';
const IFRAME_HOST_LOCAL_STORAGE_KEY = 'credit-memos-editor-iframe-host-url';
export function getHostUrl() {
  let localOverride;
  try {
    localOverride = localStorage[IFRAME_HOST_LOCAL_STORAGE_KEY];
  } catch (e) {
    // Do nothing
  }
  if (localOverride) {
    return localOverride;
  }
  const host = window.location.host;
  return host.includes('local') ? host.replace('local', 'app') : host;
}
export function getPathname() {
  return `/credit-memos-editor-ui/${PortalIdParser.get()}`;
}
export function getIframeSrc() {
  return `https://${getHostUrl()}${getPathname()}/embedded`;
}
export const getEditorRoute = (operation, objectId) => {
  const route = (() => {
    switch (true) {
      case operation === CreditMemoOperation.EDIT:
        return `/edit/${objectId}`;
      case operation === CreditMemoOperation.CREATE:
        return `/create`;
      default:
        return null;
    }
  })();
  return `https://${getHostUrl()}${getPathname()}/embedded${route}`;
};